module.exports = __webpack_public_path__ + "static/media/parameswara.8295b05b.png";